import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const topics = ["General Inquiry", "Tryouts", "Sponsorship", "Camps & Clinics", "Coaching"];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", topic: "General Inquiry", message: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contact", form);
      toast.success("Message sent — we'll respond soon.");
      setForm({ name: "", email: "", phone: "", topic: "General Inquiry", message: "" });
    } catch { toast.error("Failed to send"); }
  };
  return (
    <div data-testid="contact-page" className="py-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h1 className="font-display text-5xl sm:text-6xl uppercase font-bold tracking-tight">Contact</h1>
        <p className="text-slate-400 mt-4">Questions? We'd love to hear from you.</p>
        <form onSubmit={submit} className="kr-card rounded-xl p-8 mt-10 space-y-4" data-testid="contact-form">
          <input required placeholder="Your Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
          <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
          <input placeholder="Phone (optional)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
          <select value={form.topic} onChange={(e) => setForm({ ...form, topic: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3">
            {topics.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <textarea required rows={5} placeholder="Message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
          <button className="btn-primary w-full justify-center" data-testid="contact-submit">Send Message</button>
        </form>
      </div>
    </div>
  );
}
